module.exports = __webpack_public_path__ + "images/emoji/clock1030.06142acbcadc5bce8628.png";